module.exports = __webpack_public_path__ + "media/img/Landing_Page/pdp-feature-image-0b76fc22670086c9cf3fef162d19b254.png";